const applications = {
    page_title: 'แอปพลิเคชัน',
    title: 'แอปพลิเคชัน',
    subtitle: 'สร้างและจัดการแอปพลิเคชันสำหรับการรับรองความถูกต้อง OIDC',
    subtitle_with_app_type: 'ตั้งค่าการยืนยันตัวตน Logto สำหรับแอปพลิเคชัน {{name}} ของคุณ',
    create_device_flow_description: 'สร้างแอปพลิเคชันเนทีฟที่ใช้ OAuth 2.0 Device Authorization Grant สำหรับอุปกรณ์ที่มีการป้อนข้อมูลจำกัดหรือแอปแบบ headless',
    create: 'สร้างแอปพลิเคชัน',
    create_third_party: 'สร้างแอปพลิเคชันของบุคคลที่สาม',
    create_thrid_party_modal_title: 'สร้างแอปของบุคคลที่สาม ({{type}})',
    application_name: 'ชื่อแอปพลิเคชัน',
    application_name_placeholder: 'แอปของฉัน',
    application_description: 'คำอธิบายแอปพลิเคชัน',
    application_description_placeholder: 'กรอกคำอธิบายแอปพลิเคชันของคุณ',
    select_application_type: 'เลือกประเภทแอปพลิเคชัน',
    no_application_type_selected: 'คุณยังไม่ได้เลือกประเภทแอปพลิเคชัน',
    application_created: 'สร้างแอปพลิเคชันสำเร็จแล้ว',
    tab: {
        my_applications: 'แอปของฉัน',
        third_party_applications: 'แอปของบุคคลที่สาม',
    },
    app_id: 'App ID',
    type: {
        native: {
            title: 'แอปเนทีฟ',
            subtitle: 'แอปที่ทำงานในสภาพแวดล้อมเนทีฟ',
            description: 'เช่น แอป iOS, แอป Android, แอปเดสก์ท็อป, ทีวี, CLI',
        },
        spa: {
            title: 'แอปหน้าเดียว',
            subtitle: 'แอปที่ทำงานในเว็บเบราว์เซอร์และอัปเดตข้อมูลแบบไดนามิก',
            description: 'เช่น แอป React DOM , แอป Vue',
        },
        traditional: {
            title: 'เว็บไซต์ดั้งเดิม',
            subtitle: 'แอปที่เรนเดอร์และอัปเดตหน้าโดยเว็บเซิร์ฟเวอร์เท่านั้น',
            description: 'เช่น Next.js , PHP',
        },
        machine_to_machine: {
            title: 'เครื่องสู่เครื่อง',
            subtitle: 'แอป (โดยปกติเป็นบริการ) ที่เชื่อมต่อกับทรัพยากรโดยตรง',
            description: 'เช่น บริการฝั่งเซิร์ฟเวอร์',
        },
        protected: {
            title: 'แอปที่ถูกป้องกัน',
            subtitle: 'แอปที่ได้รับการป้องกันโดย Logto',
            description: 'ไม่มีข้อมูล',
        },
        saml: {
            title: 'แอป SAML',
            subtitle: 'แอปที่ใช้เป็นตัวเชื่อมต่อ SAML IdP',
            description: 'เช่น SAML',
        },
        third_party: {
            title: 'แอปของบุคคลที่สาม',
            subtitle: 'แอปที่ใช้เป็นตัวเชื่อมต่อ IdP ของบุคคลที่สาม',
            description: 'เช่น OIDC',
        },
    },
    authorization_flow: {
        title: 'โฟลว์การอนุญาต',
        tooltip: 'เลือกโฟลว์การอนุญาตสำหรับแอปพลิเคชันของคุณ เมื่อตั้งค่าแล้วจะไม่สามารถเปลี่ยนแปลงได้',
        authorization_code: {
            title: 'Authorization code',
            description: 'ประเภทการอนุญาตเริ่มต้นและพบบ่อยที่สุด ผู้ใช้จะถูกเปลี่ยนเส้นทางไปยังหน้าลงชื่อเข้าใช้เพื่ออนุญาตการเข้าถึงโดยตรง',
        },
        device_flow: {
            title: 'Device flow',
            description: 'สำหรับอุปกรณ์ที่มีข้อจำกัดในการป้อนข้อมูลหรือแอปแบบ headless (เช่น ทีวี, CLI) ผู้ใช้จะทำการเข้าสู่ระบบบนอุปกรณ์อื่นโดยการป้อนรหัสอุปกรณ์หรือสแกน QR โค้ด',
        },
    },
    placeholder_title: 'เลือกประเภทแอปพลิเคชันเพื่อดำเนินการต่อ',
    placeholder_description: 'Logto ใช้เอนทิตีแอปพลิเคชันสำหรับ OIDC เพื่อช่วยในงานต่าง ๆ เช่น การระบุแอป การจัดการการเข้าสู่ระบบ และสร้างบันทึกการตรวจสอบ',
    third_party_application_placeholder_description: 'ใช้ Logto เป็นผู้ให้บริการระบุตัวตนเพื่อให้การอนุญาต OAuth แก่บริการของบุคคลที่สาม \n รวมถึงหน้าจอขอความยินยอมของผู้ใช้ที่สร้างไว้ล่วงหน้าสำหรับการเข้าถึงทรัพยากร <a>เรียนรู้เพิ่มเติม</a>',
    dynamic_app: {
        title: 'แอปแบบไดนามิก',
        subtitle: 'CIMD',
        description: 'แอปแบบไดนามิกช่วยให้ไคลเอ็นต์ OAuth เชื่อมต่อได้โดยไม่ต้องลงทะเบียนล่วงหน้า',
        settings_description: 'แอปแบบไดนามิกช่วยให้ไคลเอ็นต์ OAuth เชื่อมต่อได้โดยไม่ต้องลงทะเบียนล่วงหน้า โดยใช้ข้อกำหนด OAuth Client ID Metadata Document (CIMD)',
        app_id_placeholder: 'ระบุแบบไดนามิกโดยไคลเอ็นต์แต่ละราย',
        enable_confirm_modal: {
            title: 'เปิดใช้งานการเข้าถึงของไคลเอ็นต์แบบไดนามิกหรือไม่?',
            content: 'ไคลเอ็นต์ OAuth ใดก็ตามที่มี URL ของรหัสไคลเอ็นต์แบบ HTTPS สาธารณะที่ถูกต้อง สามารถเริ่มการให้สิทธิ์กับเทแนนต์นี้ได้โดยไม่ต้องลงทะเบียนล่วงหน้า การเข้าถึงยังคงถูกจำกัดด้วยสิทธิ์สูงสุดของคุณและความยินยอมของผู้ใช้',
        },
        enabled: 'เปิดใช้งานแอปแบบไดนามิกเรียบร้อยแล้ว',
        disable_confirm_modal: {
            title: 'ปิดใช้งานแอปแบบไดนามิกหรือไม่?',
            content: 'ไคลเอ็นต์ CIMD จะไม่สามารถเริ่มคำขอการอนุญาตใหม่ได้อีกต่อไป การอนุญาตที่มีอยู่จะยังคงอยู่ และโทเค็นการเข้าถึงที่ออกไปแล้วอาจยังใช้งานได้จนกว่าจะหมดอายุ',
        },
        disabled: 'ปิดใช้งานแอปแบบไดนามิกสำเร็จแล้ว',
        permissions: {
            user_title: 'ผู้ใช้',
            user_description: 'เลือกสิทธิ์ที่ไคลเอนต์ OAuth ร้องขอสำหรับใช้เข้าถึงข้อมูลผู้ใช้',
            grant_user_level_permissions: 'ให้สิทธิ์ผู้ใช้',
            organization_title: 'องค์กร',
            organization_description: 'เลือกสิทธิ์ที่ไคลเอนต์ OAuth ร้องขอสำหรับใช้เข้าถึงข้อมูลองค์กร',
            grant_organization_level_permissions: 'ให้สิทธิ์องค์กร',
            permission_delete_confirm: 'การดำเนินการนี้จะลบสิทธิ์ออกจากแอปแบบไดนามิก ทำให้ไคลเอนต์ OAuth ไม่สามารถขออนุญาตผู้ใช้สำหรับสิทธิ์นี้ได้ คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?',
        },
    },
    guide: {
        third_party: {
            title: 'ผสานรวมแอปพลิเคชันของบุคคลที่สาม',
            description: 'ใช้ Logto เป็นผู้ให้บริการข้อมูลประจำตัวเพื่อให้การอนุญาต OAuth แก่บริการของบุคคลที่สาม พร้อมหน้าจอขอความยินยอมของผู้ใช้ที่สร้างไว้ล่วงหน้าเพื่อการเข้าถึงทรัพยากรอย่างปลอดภัย <a>เรียนรู้เพิ่มเติม</a>',
        },
    },
};
export default Object.freeze(applications);
